<template>
  <div class="space-y-3">
    <AgentConnectorEndpoints
      :options="filteredApiEndpointOptions"
      :selected-id="selectedApiEndpointToAdd"
      :selected-ids="form.api_connector_endpoint_ids"
      :single="true"
      @update:selectedId="$emit('update:selectedApiEndpointToAdd', $event)"
      @add="$emit('add-api-endpoint')"
      @remove="$emit('remove-api-endpoint', $event)"
    />
  </div>
</template>

<script>
import AgentConnectorEndpoints from './AgentConnectorEndpoints.vue'

export default {
  name: 'AgentSpecialtyRecordCreationForm',
  components: { AgentConnectorEndpoints },
  props: {
    form: { type: Object, required: true },
    filteredApiEndpointOptions: { type: Array, default: () => [] },
    selectedApiEndpointToAdd: { type: [Number, null], default: null }
  },
  emits: ['update:selectedApiEndpointToAdd', 'add-api-endpoint', 'remove-api-endpoint']
}
</script>
